import { z } from "zod";
/**
 * Validation schema for updating user data.
 */
export const updateValidationSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  designation: z.string().min(1, { message: "Designation is required" }),
  contact: z.string().min(1, { message: "Contact number is required" }),
  country_code: z.string(),
  company: z.string().min(1, { message: "Company Name is required" }),
  // working_hrs: z
  //   .number("Working hours required")
  //   .refine((value) => parseInt(value) > 0 && parseInt(value) < 25, {
  //     message: "working hours must be in between 1-24",
  //   }),
  working_hrs: z.number().optional(),
  avatar: z.string().optional(),
});
